import { z } from "zod";
import { patientApi } from "./ApiClient";

const jwtSchema = z.object({ baseUrl: z.string(), token: z.string() });

export const getCenterJwt = async () => {
  const url = `center/chat/token`;

  return await patientApi.post(url).json(jwtSchema);
};
